export const calendarBarColors: Record<string, string> = {
    workshop: '#978cc0',
    livechallenge: '#7c6eb0',
    assessment: '#5a0064',
    pitch: '#45004d',
    span: '#dddddd',
};
